import { Link } from "react-router-dom";
import { Tag, Key, Briefcase, ShoppingBag, ArrowRight, Sparkles, Handshake, CalendarDays, Users, Heart, HandHeart } from "lucide-react";

const TILES = [
  { to: "/market",       icon: Tag,          title: "Buy & Sell",     blurb: "Physical goods from real humans — one-off items paid securely on Hoomanz.", testid: "mp-market" },
  { to: "/rentals",      icon: Key,          title: "Rentals",        blurb: "Homes, cars, gear, studios — by the hour, day, week, or month.",           testid: "mp-rentals" },
  { to: "/jobs",         icon: Briefcase,    title: "Jobs",           blurb: "Hire another Hooman or find your next role.",                              testid: "mp-jobs" },
  { to: "/shop",         icon: ShoppingBag,  title: "Shop",           blurb: "Digital products, courses, prints, made-to-order items.",                 testid: "mp-shop" },
  { to: "/collabs",      icon: Handshake,    title: "Collabs",        blurb: "Team up — find co-founders, co-artists, co-organisers. Post or browse.",  testid: "mp-collabs" },
  { to: "/meetups",      icon: CalendarDays, title: "Meetups",        blurb: "Local, in-person gatherings around shared interests, skills & passions.", testid: "mp-meetups" },
  { to: "/groups",       icon: Users,        title: "Groups",         blurb: "Private and public communities — chat, media, events, paid memberships.",  testid: "mp-groups" },
  { to: "/charities",    icon: Heart,        title: "Charities",      blurb: "Post a cause. Donors give any amount — a 2 % Hoomanz Tip is added on top so the cause keeps 100 %.", testid: "mp-charities" },
  { to: "/volunteering", icon: HandHeart,    title: "Volunteering",   blurb: "Show up for something bigger — post or join volunteer events near you.",  testid: "mp-volunteering" },
  { to: "/sell",         icon: Sparkles,     title: "Start selling",  blurb: "Post a listing, service, job, or rental in under a minute.",              testid: "mp-sell" },
];

export default function Marketplace() {
  return (
    <div className="max-w-5xl mx-auto px-6 sm:px-8 py-14" data-testid="marketplace-hub">
      <p className="overline mb-2">The Marketplace</p>
      <h1 className="h-display text-4xl sm:text-5xl">Everything, from real humans.</h1>
      <p className="text-[#454545] mt-3 max-w-xl">All transactions run through Hoomanz — a 2 % Hoomanz Tip is added on top so sellers keep 100 % of their price.</p>

      <div className="grid sm:grid-cols-2 gap-3 mt-10">
        {TILES.map(({ to, icon: Icon, title, blurb, testid }) => (
          <Link key={to} to={to} data-testid={testid}
            className="card p-6 flex items-start gap-4 group hover:border-[#0057FF] transition-colors">
            <span className="h-11 w-11 rounded-full bg-[#F5F5F5] group-hover:bg-[#0057FF] group-hover:text-white text-[#050505] inline-flex items-center justify-center transition-colors flex-shrink-0">
              <Icon size={18}/>
            </span>
            <div className="flex-1 min-w-0">
              <p className="font-medium text-[15px]">{title}</p>
              <p className="text-sm text-[#454545] mt-1">{blurb}</p>
            </div>
            <ArrowRight size={16} className="text-[#8C8C8C] group-hover:text-[#0057FF] group-hover:translate-x-1 transition-all flex-shrink-0 mt-1"/>
          </Link>
        ))}
      </div>
    </div>
  );
}
